import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";

import ChevronIcon from "../assets/icons/chevron.svg";
import "./components.css";

// One project card, used on both the homepage and the Work page so they stay
// consistent. The whole card is a single link to the project page.
export default function WorkCard({ project, left, white, headingLevel = "h3" }) {
	const controls = useAnimation();
	const Heading = headingLevel;

	const { ref, inView } = useInView({
		triggerOnce: true,
		threshold: 0.1,
		rootMargin: "90% 0px",
	});

	useEffect(() => {
		if (inView) {
			controls.start({
				opacity: 1,
				scale: 1,
				y: 0,
				transition: { duration: 1 },
			});
		}
	}, [controls, inView]);

	const audience =
		project.users &&
		`For ${project.users[0].toLowerCase()}${project.users.slice(1)}`;
	const meta = [project.date, audience].filter(Boolean);

	return (
		<motion.div
			className={`work-card ${white ? "white" : ""} ${left ? "left" : ""}`}
			animate={controls}
			initial={{ opacity: 0, scale: 0.5, y: "100vh" }}
			ref={ref}
		>
			<Link className="work-card-link" to={`/works/${project.slug}`}>
				<div className="work-card-media">
					<img
						src={project.image}
						className="project-image"
						alt={project.imageAlt}
					/>
				</div>
				<div className="content">
					<div className="tags">
						{project.status && (
							<span className="tag">
								<span className="inner-tag">{project.status}</span>
							</span>
						)}
						<span className="tag">
							<span className="inner-tag">{project.type}</span>
						</span>
					</div>
					<div className="inner-content">
						<Heading className="card-title">{project.name}</Heading>
						<p>{project.summary}</p>
						{meta.length > 0 && (
							<p className="card-meta">{meta.join(" · ")}</p>
						)}
					</div>
					<span className="link-project">
						{project.linkLabel}
						<span className="visually-hidden">: {project.name}</span>
						<img src={ChevronIcon} alt="" className="animated-icon" />
					</span>
				</div>
			</Link>
		</motion.div>
	);
}
